import React from "react";
const ModalContext = React.createContext(void 0);
export {
  ModalContext
};
//# sourceMappingURL=types.js.map
